/* ===========================================================
 * 
 *   Responsive Background Images.
 * 
 *   Make background images responsive by parsing 
 *   a child img tag with srcset
 * 
 *   Provides a global function:
 *     responsiveBackgroundImages();
 * 
 *   To be called whenever elements containing
 *   responsive backgrounds are added to the DOM
 * 
 * ===========================================================*/

/**
 * Process the elements with pending background images
 */
 var responsiveBackgroundImages = function() {

    //return;

    //  Get all the matching elements on the page
    _lazyElements = document.querySelectorAll('[data-lazysrc]');

    //  For each one, lazy-load the image
    for (i=0; i<_lazyElements.length; i++) {
        
        //  Get the element
        _img = _lazyElements[i];

        //  Source path
        _src = _img.getAttribute('data-lazysrc');
        _srcet = _img.getAttribute('data-lazysrcset');
        
        _img.removeAttribute('data-lazysrc');
        _img.removeAttribute('data-lazysrcset');

        _img.srcset = _srcet;
        _img.src = _srcet;
    }

    //  Get all the matching elements on the page
    _elements = document.querySelectorAll('[data-responsive-background-image]');

    //  For each one, load load the background image
    for (i=0; i<_elements.length; i++) {
        
        //  Get the element
        _element = _elements[i];

        //  Get the child image
        _img = _element.querySelector('img');

        //  Source placeholder
        _src = '';

        //  Does the image exist?
        if (_img) {


            src = typeof(_img.currentSrc) !== 'undefined' ? _img.currentSrc : _img.src;
            
            if (typeof (_img) !== 'undefined') {

                //  If already loaded, process it now
                if (_img.complete) {

                    src = typeof(_img.currentSrc) !== 'undefined' ? _img.currentSrc : _img.src;
                    if (_src !== src) {
                        _src = src;
                        _element.style.backgroundImage = 'url("' + _src + '")';
                        _element.removeAttribute('data-responsive-background-image');
                    }
                }

                //  Also add an event listener, so we process a lazy-loaded image
                _img.addEventListener('load', function( e ) {

                    //  Event variables
                    var e_img, e_element, e_src;

                    //  Chrome/Webkit?
                    if (typeof(e.path) !== 'undefined') {
                        e_img = e.path[0];
                    }

                    //  FF?
                    else if (typeof(e.srcElement) !== 'undefined') {
                        e_img = e.srcElement;
                    }

                    //  No img object found, so do nothing
                    else {
                        return;
                    }

                    //  Get the image parent container
                    e_element = e_img.parentElement;

                    //  Get the image source
                    e_src = typeof (e_img.currentSrc) !== 'undefined' ? e_img.currentSrc : e_img.src;

                    //  Was a source found?
                    if (e_img) {

                        //  Update the parent element background
                        e_element.style.backgroundImage = 'url("' + e_src + '")';

                        //  Remove the data attr from the parent so it is not processed again
                        e_element.removeAttribute('data-responsive-background-image');
                    }
                });
            }
        }
    }
};

responsiveBackgroundImages();